/* eslint-disable max-len */
/* eslint-disable func-names */
/* eslint-disable object-shorthand */

import DOMPurify from "dompurify";
import jQuery3 from './rfct/jQuery/jQuery';

// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}

// eslint-disable-next-line import/prefer-default-export
export function bindCatalogSearchInputAutocomplete($input, autocompleteHeadline) {
    $input.autocomplete({
        appendMethod: 'replace',
        valid: function () {
            return true;
        },
        source: [
            function (q, add) {
                const suggestions = [];
                if (q !== '') {
                    let catalogID = '';
                    if (jQuery.urlParam('cat') && jQuery.urlParam('cat') !== '') {
                        catalogID = jQuery.urlParam('cat');
                    } else if (jQuery.urlParam('div') && jQuery.urlParam('div') !== '') {
                        catalogID = jQuery.urlParam('div');
                    }

                    const jsonNamesURL = `${$globalConfig.urls.getProductSuggestionJson}?autocompletenames=true&q=${encodeURIComponent(q)}&suggest.cfq=${catalogID}`;
                    const jsonProductsURL = `${$globalConfig.urls.getProductSuggestionJson}?q=${encodeURIComponent(q)}&suggest.cfq=${catalogID}`;
                    jQuery.getJSON(jsonNamesURL, (rowNamesData) => {
                        const key = Object.keys(rowNamesData.suggest.filteredProductNamesSuggesterDictionary)[0];
                        const results = rowNamesData.suggest.filteredProductNamesSuggesterDictionary[key].suggestions;
                        if (results.length > 0) {
                            results.forEach((suggestion) => {
                                suggestions.push(suggestion.term);
                            });
                            add(unique(suggestions));
                        } else {
                            jQuery.getJSON(jsonProductsURL, (rowProductsdata) => {
                                const collationValues = (rowProductsdata && rowProductsdata.spellcheck && rowProductsdata.spellcheck.collations) ? rowProductsdata.spellcheck.collations : [];
                                collationValues.forEach((collation) => {
                                    if (collation !== 'collation') {
                                        suggestions.push(collation);
                                    }
                                });
                                add(unique(suggestions));
                            });
                        }
                    });
                }
            },
        ],
        render: function (item, source, pid, query) {
            const value = typeof item === 'string' ? item : item[this.valueKey];
            const title = typeof item === 'string' ? item : item[this.titleKey];
            return `<div ${(value === query ? 'class="active"' : '')} data-value="${encodeURIComponent(value)}"${(autocompleteHeadline ? ` data-headline="${autocompleteHeadline}"` : '')}><span>${title}</span></div>`;
        },
        minLength: 2,
    });
}

jQuery(document).ready((jQuery) => {
    bindCatalogSearchInputAutocomplete(
        jQuery('#catalog__search-input'),
    );

    jQuery('#eifu__search-input').autocomplete({
        appendMethod: 'replace',
        valid: function () {
            return true;
        },
        source: [
            function (q, add) {
                const suggestions = [];
                const url = new URL(window.location.href);
                const language = url.searchParams.get('language') ? `&language=${DOMPurify.sanitize(url.searchParams.get('language'))}` : '';
                const country = url.searchParams.get('country') ? `&country=${DOMPurify.sanitize(url.searchParams.get('country'))}` : '';
                if (q !== '') {
                    const jsonURL = `${$globalConfig.urls.getEifuSuggestionJson}?q=${encodeURIComponent(q)}${language}${country}`;
                    jQuery.getJSON(jsonURL, (data) => {
                        const key = Object.keys(data.suggest.filteredProductNamesForIfuSuggesterDictionary)[0];
                        const results = data.suggest.filteredProductNamesForIfuSuggesterDictionary[key].suggestions;
                        if (results.length > 0) {
                            results.forEach((suggestion) => {
                                suggestions.push(suggestion.term);
                            });
                            add(unique(suggestions));
                        } else {
                            add(unique(suggestions));
                        }
                    });
                }
            },
        ],
        minLength: 2,
    });
});

function unique(list) {
    const result = [];
    $.each(list, (i, e) => {
        if ($.inArray(e, result) === -1) result.push(e);
    });
    return result;
}

function initCatalogSearchAutocomplete() {
    jQuery3(document).ready(() => {
        const $buttonGroup = jQuery3('#rfct-search-input-button-group');
        const $searchInput = $buttonGroup.find('.rfct-input__input');
        const autocompleteHeadline = $buttonGroup.attr('data-autocomplete-headline');
        bindCatalogSearchInputAutocomplete($searchInput, autocompleteHeadline);
    });
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    initCatalogSearchAutocomplete();
}
